import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CodeEditorModule } from '@portal-core/code-editor/components/code-editor/code-editor.module';
import { CollabFileTextEditorStatusBarModule } from '@portal-core/text-editor/components/collab-file-text-editor-status-bar/collab-file-text-editor-status-bar.module';
import { CollabValidationErrorTextModule } from '@portal-core/text-editor/pipes/collab-validation-error-text/collab-validation-error-text.module';
import { CollabCodeEditorComponent } from './collab-code-editor.component';

@NgModule({
  declarations: [
    CollabCodeEditorComponent
  ],
  imports: [
    CodeEditorModule,
    CollabValidationErrorTextModule,
    CollabFileTextEditorStatusBarModule,
    CommonModule
  ],
  exports: [
    CollabCodeEditorComponent
  ]
})
export class CollabCodeEditorModule { }
